"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
class CollectorItem {
  constructor() {
    this.id = "";
    this.label = "";
  }
}
let GridSelector = class extends Vue {
  constructor() {
    super(...arguments);
    this.opt_span_1 = 12;
    this.opt_span_2 = 12;
    this.disableBtn = false;
    this.listData = new Array();
    this.showData = new Array();
    this.changed = _.debounce((listData) => {
      this.$emit("changed", listData);
    }, 200);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  computed() {
    disablebtn:
      () => {
        if (this.disableBtn) {
          return false;
        }
      };
    opt_span_1:
      () => {
        return this.opt_span_1;
      };
    opt_span_2:
      () => {
        return this.opt_span_2;
      };
  }
  setBtn(flag = false) {
    this.disableBtn = flag;
  }
  setOptSpan(span_1, span_2) {
    this.opt_span_1 = span_1;
    this.opt_span_2 = span_2;
  }
  search() {
    this.showData = JSON.parse(JSON.stringify(this.listData));
    this.changed(this.listData);
  }
  getAll() {
    this.search();
    return this.listData;
  }
  getAllNew() {
    return this.listData;
  }
  syncData(allData, selectData, idName = "id", labelName = "name") {
    let unSelectData = _.differenceWith(
      allData,
      selectData,
      _.isEqual
    );
    for (const item of selectData) {
      const _item = {
        id: item[idName],
        label: item[labelName]
      };
      this.add(_item);
    }
    for (const item of unSelectData) {
      const _item = {
        id: item[idName],
        label: item[labelName]
      };
      this.del(_item);
    }
  }
  add(item) {
    let _item = _.find(this.listData, { id: item.id });
    if (_item === void 0) {
      this.listData.push(item);
    }
    this.search();
  }
  save() {
    this.$emit("saved", this.getAll());
  }
  del(itme) {
    let data = _.find(this.listData, { "id": itme.id });
    if (data !== void 0) {
      this.listData = _.filter(this.listData, (data2) => {
        return data2.id !== itme.id;
      });
      this.search();
    }
  }
  clear() {
    this.listData = new Array();
    this.showData = new Array();
    this.search();
  }
  close() {
    this.$emit("close");
  }
};
GridSelector = __decorateClass([
  Component({
    components: {}
  })
], GridSelector);
export {
  GridSelector as default
};
